module.exports = __webpack_public_path__ + "img/Kris Lui.2c4b9378.webp";